module.exports = "pegasus_template/assets/theme4/google-icon.png";